<template>
  <div class="md-layout">
    <CSLoading :is-loading="isLoading"></CSLoading>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green with-toolbar">
          <div class="card-icon">
            <md-icon>grade</md-icon>
          </div>
          <h4 class="title">{{ $t("layout.shipping") }}</h4>
          <div class="card-toolbar">
            <md-button v-if="hasPermission('Write', 'Orders', 'Split')" @click="showSplitModal" class="md-icon-button md-info text-white split-button">
              <md-icon md-src="/img/arrow_split.svg" />
            </md-button>
            <md-button v-if="hasPermission('Write', 'Orders', 'Create')" @click="showAddManulaOrderModal" class="md-icon-button md-success add-button">
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-10">
              <md-field md-clearable>
                <label>{{ $t("orders.invoiceNumber") }}</label>
                <md-input v-model="filter.invoiceNumber" @input="debounceApplyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-15">
              <md-field md-clearable>
                <label>{{ $t("orders.keywords") }}</label>
                <md-input v-model="filter.keywords" @input="debounceApplyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                <label v-if="!!filter.shippingStatusId">{{ $t("orders.status") }}</label>
                <SelectOrderStatus :value="filter.shippingStatusId" :multiple="true" :customClass="'custom-select'" @input="handleChangeStatus" />
              </div>
            </div>
            <div class="md-layout-item md-size-10">
              <md-field md-clearable>
                <label>{{ $t("orders.sku") }}</label>
                <md-input v-model="filter.sku" @input="debounceApplyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-15">
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                <label v-if="!!filter.carrier">{{ $t("orders.carrier") }}</label>
                <SelectCarrier :multiple="true" :customClass="'custom-select'" @input="handleChangeCarrier" />
              </div>
            </div>
            <div class="md-layout-item md-size-10">
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                <label v-if="!!filter.pickTypes">{{ $t("orders.pickType") }}</label>

                <SelectPickType :multiple="true" :customClass="'custom-select'" @input="handleChangePickTypes" />
              </div>
            </div>
            <div class="md-layout-item md-size-10">
              <md-field :md-clearable="!isWarehouseAssigned">
                <label>{{ $t("wms.warehouse") }}</label>
                <md-select v-model="filter.warehouseId" name="warehouseId" id="warehouseId" :disabled="isWarehouseAssigned" @md-selected="debounceApplyFilters">
                  <md-option :key="i.id" v-for="i in warehouseOptions" :value="i.id">{{ i.name }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-10">
              <md-field md-clearable>
                <label>{{ $t("wms.areaSector") }}</label>
                <md-select v-model="filter.storageLocationLevel1" name="storageLocationLevel1" id="storageLocationLevel1" @md-selected="debounceApplyFilters">
                  <md-option :key="lvl" v-for="lvl in level1Options" :value="lvl">{{ lvl }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout orders-filter-row2">
            <div class="md-layout-item md-size-15">
              <p class="date-title">{{ $t("orders.orderDateFrom") }}</p>
              <simple-date-time-picker
                :id="`orderDateFrom`"
                @datetimeChanged="(d) => dateFilterChanaged(d, 'orderDateFrom')"
                @clearDatetime="() => clearDatetime('orderDateFrom')"
              ></simple-date-time-picker>
            </div>
            <div class="md-layout-item md-size-15">
              <p class="date-title">{{ $t("orders.orderDateTo") }}</p>
              <simple-date-time-picker :id="`orderDateTo`" @datetimeChanged="(d) => dateFilterChanaged(d, 'orderDateTo')" @clearDatetime="() => clearDatetime('orderDateTo')"></simple-date-time-picker>
            </div>
            <div class="md-layout-item md-size-15">
              <p class="date-title">{{ $t("orders.shippedDateFrom") }}</p>
              <simple-date-time-picker
                :id="`shippedDateFrom`"
                @datetimeChanged="(d) => dateFilterChanaged(d, 'shippedDateFrom')"
                @clearDatetime="() => clearDatetime('shippedDateFrom')"
              ></simple-date-time-picker>
            </div>
            <div class="md-layout-item md-size-15">
              <p class="date-title">{{ $t("orders.shippedDateTo") }}</p>
              <simple-date-time-picker
                :id="`shippedDateTo`"
                @datetimeChanged="(d) => dateFilterChanaged(d, 'shippedDateTo')"
                @clearDatetime="() => clearDatetime('shippedDateTo')"
              ></simple-date-time-picker>
            </div>

            <div class="md-layout md-layout-item md-size-15">
              <md-checkbox v-model="enableBulky">{{ $t("products.bulky") }}</md-checkbox>
              <md-switch v-model="filterBulky" :disabled="!enableBulky" />
            </div>
            <div class="md-layout md-layout-item md-size-15">
              <!-- default aus = kein Filter; an = nur Vorgaenge mit Rekla-Fotos (Trello 21.08.) -->
              <md-switch v-model="filterReklaImages">{{ $t("orders.images.filterLabel") }}</md-switch>
            </div>
            <div class="md-layout-item md-size-20">
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 0">
                <label v-if="addressValidationStatusFilter.length">{{ $t("orders.addressValidation.filterLabel") }}</label>
                <v-select
                  v-model="addressValidationStatusFilter"
                  :multiple="true"
                  :searchable="false"
                  label="name"
                  :options="addressValidationFilterOptions"
                  :placeholder="$t('orders.addressValidation.filterLabel')"
                  class="select-chip custom-select"
                  @input="onValidationFilterChange"
                >
                  <template slot="no-options"> {{ $t("noRecord") }} </template>
                  <template slot="option" slot-scope="option">
                    <span class="validation-dot" :class="`validation-status-${option.id}`" style="margin-right: 6px"></span>{{ option.name }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <span class="validation-dot" :class="`validation-status-${option.id}`" style="margin-right: 4px"></span>{{ option.name }}
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="mb-5" style="margin-top: 1rem"></div>
          <md-menu v-if="hasAnyOrderAction" md-size="medium" :md-offset-x="127" :md-offset-y="-41">
            <md-button md-menu-trigger class="md-success">{{ $t("orders.run") }}</md-button>

            <md-menu-content>
              <md-menu-item v-if="hasPermission('Write', 'Orders', 'Export')" @click="exportModal = true">
                {{ $t("orders.export") }}
              </md-menu-item>
              <md-menu-item v-if="hasPermission('Write', 'Orders', 'Send')" @click="setStatusModal = true">
                {{ $t("orders.send") }}
              </md-menu-item>
              <md-menu-item v-if="hasPermission('Write', 'Orders', 'Delete')" @click="deleteModal = true">
                {{ $t("orders.delete") }}
              </md-menu-item>
              <md-menu-item v-if="hasPermission('Write', 'Orders', 'HardDelete')" @click="hardDeleteModal = true">
                {{ $t("orders.hardDelete") }}
              </md-menu-item>
              <md-menu-item v-if="hasPermission('Write', 'Orders', 'ValidateAddresses')" @click="validateAddressesModal = true">
                {{ $t("orders.addressValidation.action") }}
              </md-menu-item>
            </md-menu-content>
          </md-menu>
          <vue-json-to-csv ref="csvGenerator" v-if="hasPermission('Read', 'Orders', '')" :json-data-generator="exportOrders" separator=";" :csv-title="getExportOrderTitle()">
            <span v-show="false" />
            <!-- override slot default with emptiness/ghost element -->
          </vue-json-to-csv>
          <div class="table-sticky">
            <v-server-table :columns="tableColumns" :options="tableOptions" ref="table" class="table-orders" id="table-orders">
              <template #h__actions>
                <div class="head-selected" style="width: 100px">
                  <input ref="checkAllInput" v-if="canSelectOrders()" type="checkbox" :disabled="!shouldShowCheckAll" :checked="hasCheckedAll" @click="handleCheckAll()" />
                  <br />
                  <span v-if="!hasCheckedAll">
                    {{
                      $tc("table.selected", totalItems, {
                        num: totalSelectedItems,
                        count: totalItems,
                      })
                    }}
                  </span>
                  <span v-else>{{ $tc("table.selectedAll", totalItems) }}</span>
                </div>
              </template>
              <template #h__status>
                <span>{{ $t("orders.status") }}</span>
                <br />
                <span>{{ $t("orders.pickType") }}</span>
              </template>
              <template #h__customer>
                <div class="head-customer">
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerInvoiceNumber')">{{ $t("orders.receiptNumber") }}</span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerIdNumber')"><br />{{ $t("orders.customerNumber") }}</span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerOrderId')"><br />{{ $t("orders.customerOrderId") }}</span>
                </div>
              </template>
              <template #h__shipping>
                <div class="head-shipping">
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressCompany')">{{ $t("orders.company") }}<br /></span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressName')">{{ $t("orders.name") }}<br /></span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressStreet')">{{ $t("orders.streetAndNumber") }}<br /></span>
                  <span
                    v-if="
                      hasPermission('LimitRead', 'Orders', 'ShippingAddressCountry') ||
                      hasPermission('LimitRead', 'Orders', 'ShippingAddressZipcode') ||
                      hasPermission('LimitRead', 'Orders', 'ShippingAddressTown')
                    "
                    >{{ $t("orders.countryAndZipcode") }}</span
                  >
                </div>
              </template>
              <template #h__carrier>
                <span>{{ $t("orders.table.carrier") }}</span
                ><br />
                <span>{{ $t("orders.shippingService") }}</span
                ><br />
                <span>{{ $t("orders.shippingWeight") }}</span>
              </template>
              <template #h__orderDate>
                <div class="head-order-date">
                  <span v-if="hasPermission('LimitRead', 'Orders', 'OrderDate')">{{ $t("orders.table.orderDate") }}</span
                  ><br />
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippedDate')">{{ $t("orders.table.shippedDate") }}</span>
                </div>
              </template>
              <template #actions="{ row }">
                <div class="md-table-cell-container cell-actions">
                  {{ row.index }} <input v-if="canSelectOrders()" type="checkbox" :checked="row.selected" @click="handleSelectRow(row)" />
                  <md-button
                    class="md-icon-button"
                    style="z-index: 1"
                    v-if="row.shippingStatusId === 1 && row.pickType === 'CHECK' && hasPermission('Write', 'Orders', 'Split')"
                    @click="showSplitModal(row)"
                  >
                    <md-icon md-src="/img/arrow_split.svg" />
                  </md-button>
                  <md-button
                    class="md-icon-button"
                    style="z-index: 1"
                    v-if="(row.shippingStatusName === 'error' || row.shippingStatusName === 'unshipped') && hasPermission('Write', 'Orders', 'Edit')"
                    @click="showEditModal(row)"
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button class="md-icon-button" style="z-index: 1" v-if="hasPermission('Write', 'Orders', 'Duplicate')" @click="copy(row)">
                    <md-icon>content_copy</md-icon>
                  </md-button>
                  <!-- Reklamationsbilder hochladen (Trello 21.08.) - gruen mit weissem Bild-Icon -->
                  <md-button
                    class="md-icon-button md-success"
                    style="z-index: 1"
                    v-if="hasPermission('Write', 'Orders', 'Images') && row.customerInvoiceNumber"
                    @click="openImages(row, true)"
                  >
                    <md-icon>image</md-icon>
                  </md-button>
                </div>
              </template>
              <template #customer="{ row }">
                <div class="cell-customer">
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerInvoiceNumber')">
                    <a v-if="afterbuyOrderUrl(row)" :href="afterbuyOrderUrl(row)" target="_blank" rel="noopener" class="invoice-link"
                      ><strong>{{ row.customerInvoiceNumber }}</strong></a
                    >
                    <strong v-else>{{ row.customerInvoiceNumber }}</strong>
                    <br />
                  </span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerIdNumber')">{{ row.customerIdNumber }}</span
                  ><br />
                  <span v-if="hasPermission('LimitRead', 'Orders', 'CustomerOrderId')">{{ row.customerOrderId }}</span>
                </div>
              </template>
              <template #shipping="{ row }">
                <div class="cell-shipping">
                  <div v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressCompany')" class="address-item">
                    <md-icon>business</md-icon> <strong v-if="row.shippingAddressCompany">{{ row.shippingAddressCompany }}</strong>
                  </div>
                  <div v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressName')" class="address-item"><md-icon>person</md-icon> {{ row.shippingAddressName }}</div>
                  <div v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressStreet')" class="address-item"><md-icon>place</md-icon> {{ row.shippingAddressStreet }}</div>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressCountry')" class="address-item">
                    <md-icon>map</md-icon> {{ row.shippingAddressCountry }} - <span v-if="hasPermission('LimitRead', 'Orders', 'shippingAddressZipcode')">{{ row.shippingAddressZipcode }} </span
                    ><span v-if="hasPermission('LimitRead', 'Orders', 'ShippingAddressTown')"> {{ row.shippingAddressTown }}</span>
                  </span>
                  <div v-if="row.addressValidationStatus || row.oldAddress" class="address-item address-validation-item">
                    <span class="validation-dot" :class="`validation-status-${row.addressValidationStatus || 0}`">
                      <md-tooltip md-direction="top">
                        <div>{{ $t(`orders.addressValidation.statuses.${row.addressValidationStatus || 0}`) }}</div>
                        <div v-if="formatOldAddress(row)">{{ $t("orders.addressValidation.oldAddress") }}: {{ formatOldAddress(row) }}</div>
                      </md-tooltip>
                    </span>
                    <a v-if="row.addressValidationProposal" class="proposal-link" @click="openProposalModal(row)">
                      <md-icon class="proposal-icon">fact_check</md-icon>{{ $t("orders.addressValidation.review") }}
                    </a>
                  </div>
                </div>
              </template>
              <template #sku="{ row }">
                <div class="cell-sku">
                  <ul v-if="row.orderSkus && hasPermission('LimitRead', 'Orders', 'OrderSkus')">
                    <li v-for="s in row.orderSkus" :key="s.id">
                      <strong>{{ s.shippingSkuAmount }} x {{ s.shippingSkuName }}</strong>
                      <span v-if="s.shippingSkuCarrier || s.shippingSkuLocation">
                        &nbsp; ({{ s.shippingSkuCarrier }}{{ s.shippingSkuCarrier ? ", " : "" }}{{ parseShippingSkuLocation(s.shippingSkuLocation, s.id) }})
                      </span>
                      <span v-if="s.orderSkuBulky === 'true'" class="material-symbols-outlined shipping-bulky">
                        weight
                        <md-tooltip md-direction="top">Bulky</md-tooltip>
                      </span>
                      <div v-if="s.orderSkuDescription">{{ s.orderSkuDescription }}</div>
                    </li>
                  </ul>
                  <ul v-if="row.parts && hasPermission('LimitRead', 'Orders', 'OrderSkus')" :class="`list-parts ${row.orderSkus.length > 0 ? 'border-top' : ''}`">
                    <li v-for="s in row.parts" :key="s.id">
                      <strong>{{ s.quantity }} x {{ s.description }}</strong>
                      <span v-if="s.weight">&nbsp; {{ $t("orders.parts.weight") }}: {{ s.weight | formatUnit("kg") }}</span>

                      <span v-if="s.carrier"> &nbsp; ({{ s.carrier }}) </span>
                    </li>
                  </ul>
                </div>
              </template>
              <template #status="{ row }">
                <div v-if="hasPermission('LimitRead', 'Orders', 'ShippingStatusId')" class="cell-status">
                  <md-chip :class="row.shippingStatusName">{{ getI18N("orders.statuses.shippingStatuses", row.shippingStatusName) }}</md-chip>
                </div>
                <div v-if="hasPermission('LimitRead', 'Orders', 'PickType')" class="cell-status">
                  <md-chip :class="`order-pick-type-${row.pickType || 'na'}`"> {{ $t(`orders.pickTypes.${row.pickType || "NA"}`) }}</md-chip>
                </div>
                <div v-if="row.orderShippingCarrier === 'Spedition' && !row.phoneNumber && hasPermission('LimitRead', 'Orders', 'PhoneNumber')" class="cell-status">
                  <md-chip class="error"> {{ $t(`orders.phoneNumberMissing`) }}</md-chip>
                </div>
              </template>
              <template #reklaImages="{ row }">
                <!-- Bild-Icon nur wenn Bilder existieren (Trello 21.08.) - Ansicht ohne Upload -->
                <md-icon v-if="row.reklaImageCount > 0" class="rekla-icon" @click.native="openImages(row, false)">
                  image
                  <md-tooltip md-direction="top">{{ row.reklaImageCount }} {{ $t("orders.images.tooltip") }}</md-tooltip>
                </md-icon>
              </template>
              <template #carrier="{ row }">
                <div v-if="hasPermission('LimitRead', 'Orders', 'OutboundCarriers')" class="cell-outbound-carriers">
                  <CarrierLogo :item="row.orderShippingCarrier || ''" />
                </div>
                <div v-if="hasPermission('LimitRead', 'Orders', 'ShippingService')">
                  {{ row.shippingService || "N/A" }}
                </div>
                <div v-if="hasPermission('LimitRead', 'Orders', 'OrderShippingWeight')">{{ row.orderShippingWeight | formatNumber }} kg</div>
              </template>
              <template #orderType="{ row }">
                <div v-if="hasPermission('LimitRead', 'Orders', 'OrderType')" class="cell-order-type">
                  {{ row.orderType }}
                </div>
              </template>
              <template #orderDate="{ row }">
                <div class="cell-order-date">
                  <span v-if="hasPermission('LimitRead', 'Orders', 'OrderDate')">{{ row.orderDate | formatDateTime }} <br /></span>
                  <span v-if="hasPermission('LimitRead', 'Orders', 'ShippedDate')">{{ row.shippedDate | formatDateTime }}</span>
                </div>
              </template>
            </v-server-table>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="imageModal" @close="hideImages" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.images.title") }} {{ imageInvoiceNumber }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideImages">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <!-- deferred (Karte 24.08.): Aenderungen wirken erst mit "Speichern"; Abbrechen/X verwirft -->
        <OrderImageGallery ref="imageGallery" :invoice-number="imageInvoiceNumber" :allow-upload="imageAllowUpload" :deferred="imageAllowUpload" />
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideImages">{{ $t("orders.close") }}</md-button>
        <md-button v-if="imageAllowUpload" class="md-success" :disabled="imageSaving" @click="saveImages">{{ $t("orders.save") }}</md-button>
      </template>
    </modal>

    <modal v-if="editModal" @close="hideEditModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.editOrder") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideEditModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <tabs :tab-name="[$t('orders.order'), $t('orders.sku'), $t('orders.parts.title')]" color-button="success" content-flex-direction-column extraClass="tab-flat">
          <template slot="tab-pane-1">
            <ValidationObserver v-slot="{}" ref="editForm">
              <md-field v-if="hasPermission('Read', 'Orders', 'CustomerInvoiceNumber')">
                <label>{{ $t("orders.customerInvoiceNumber") }}</label>
                <md-input v-model="form.customerInvoiceNumber" type="text"></md-input>
              </md-field>
              <md-field v-if="hasPermission('Read', 'Orders', 'CustomerIdNumber')">
                <label>{{ $t("orders.customerIdNumber") }}</label>
                <md-input v-model="form.customerIdNumber" type="text"> </md-input>
              </md-field>
              <md-field v-if="hasPermission('Read', 'Orders', 'CustomerOrderId')">
                <label>{{ $t("orders.customerOrderId") }}</label>
                <md-input v-model="form.customerOrderId" type="text"> </md-input>
              </md-field>
              <section class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <div v-if="hasPermission('Read', 'Orders', 'ShippingStatusId')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                    <label v-if="!!form.shippingStatusId">{{ $t("orders.status") }}</label>
                    <SelectOrderStatus v-model="form.shippingStatusId" :multiple="false" :customClass="'custom-select'" />
                  </div>
                </div>
                <div class="md-layout-item md-size-50">
                  <div v-if="hasPermission('Read', 'Orders', 'orderShippingCarrier')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                    <label v-if="!!form.orderShippingCarrier">{{ $t("orders.carrier") }}</label>
                    <SelectCarrier v-model="form.orderShippingCarrier" :default="true" :multiple="false" :customClass="'custom-select'" />
                  </div>
                </div>
              </section>
              <div v-if="hasPermission('Read', 'Orders', 'pickType')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                <label v-if="!!form.pickType">{{ $t("orders.pickType") }}</label>
                <SelectPickType v-model="form.pickType" :multiple="false" :customClass="'custom-select'" />
              </div>

              <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressCompany')">
                <label>{{ $t("orders.shippingAddressCompany") }}</label>
                <md-input v-model="form.shippingAddressCompany" type="text"> </md-input>
              </md-field>
              <section class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressName')">
                    <label>{{ $t("orders.shippingAddressName") }}</label>
                    <md-input v-model="form.shippingAddressName" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'PhoneNumber')">
                    <label>{{ $t("orders.phoneNumber") }}</label>
                    <md-input v-model="form.phoneNumber" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressStreet')">
                    <label>{{ $t("orders.shippingAddressStreet") }}</label>
                    <md-input v-model="form.shippingAddressStreet" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressZipcode')">
                    <label>{{ $t("orders.shippingAddressZipcode") }}</label>
                    <md-input v-model="form.shippingAddressZipcode" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressTown')">
                    <label>{{ $t("orders.shippingAddressTown") }}</label>
                    <md-input v-model="form.shippingAddressTown" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field v-if="hasPermission('Read', 'Orders', 'ShippingAddressCountry')">
                    <label>{{ $t("orders.shippingAddressCountry") }}</label>
                    <md-input v-model="form.shippingAddressCountry" type="text"> </md-input>
                  </md-field>
                </div>
              </section>
            </ValidationObserver>
          </template>
          <template slot="tab-pane-2">
            <Skus v-model="form.orderSkus" v-if="hasPermission('Read', 'Orders', 'OrderSkus')" />
          </template>

          <template slot="tab-pane-3">
            <Parts v-model="form.parts" />
          </template>
        </tabs>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideEditModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-success" @click="editOrder">{{ $t("orders.save") }}</md-button>
      </template>
    </modal>

    <modal v-if="setStatusModal" @close="hideSetStatusModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.setStatus") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideSetStatusModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <p>{{ $t("orders.messages.shipped") }}</p>
        <p>
          {{ $t("orders.messages.sendSkipPickTypes") }}
        </p>
        <p>
          {{ $t("orders.messages.sendSkipUnvalidated") }}
        </p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideSetStatusModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-success" @click="setOrdersStatus">{{ $t("orders.save") }}</md-button>
      </template>
    </modal>

    <!-- Picklisten der gerade versendeten CAB-Auftraege, eine je Lager (Trello 08.09.2026) -->
    <pdf-preview-modal v-if="picklistPreview.show" :title="$t('orders.picklist.title')" :files="picklistPreview.files" @close="closePicklistPreview" />

    <modal v-if="deleteModal" @close="hideDeleteModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.setStatus") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideDeleteModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <p>
          {{ $t("orders.messages.delete") }}
        </p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideDeleteModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-danger" @click="setOrdersStatusDeleted">{{ $t("orders.deleted") }}</md-button>
      </template>
    </modal>

    <modal v-if="validateAddressesModal" @close="validateAddressesModal = false" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.addressValidation.action") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="validateAddressesModal = false">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <p>{{ $t("orders.addressValidation.messages.confirm", { count: totalSelectedItems }) }}</p>
        <p style="color: #999; font-size: 12px">{{ $t("orders.addressValidation.messages.confirmHint") }}</p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="validateAddressesModal = false">{{ $t("orders.close") }}</md-button>
        <md-button class="md-success" @click="validateAddresses">{{ $t("orders.addressValidation.run") }}</md-button>
      </template>
    </modal>

    <modal v-if="proposalModal" @close="hideProposalModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.addressValidation.proposalTitle") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideProposalModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <table v-if="proposalData" class="proposal-table">
          <thead>
            <tr>
              <th></th>
              <th>{{ $t("orders.addressValidation.current") }}</th>
              <th>{{ $t("orders.addressValidation.proposed") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="field in proposalFields" :key="field.key" :class="{ 'proposal-diff': field.changed }">
              <td class="proposal-label">{{ field.label }}</td>
              <td>{{ field.current || "–" }}</td>
              <td>
                <strong v-if="field.changed">{{ field.proposed || "–" }}</strong
                ><span v-else>{{ field.proposed || "–" }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="proposalReasonText" style="margin-top: 12px">
          <strong>{{ $t("orders.addressValidation.reason") }}:</strong> {{ proposalReasonText }}
          <span v-if="proposalData.source" style="color: #999"> ({{ proposalData.source === "ai" ? "KI" : $t("orders.addressValidation.sourceRules") }})</span>
        </p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideProposalModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-danger" @click="rejectProposal">{{ $t("orders.addressValidation.reject") }}</md-button>
        <md-button class="md-success" @click="acceptProposal">{{ $t("orders.addressValidation.accept") }}</md-button>
      </template>
    </modal>

    <modal v-if="hardDeleteModal" @close="hideHardDeleteModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.hardDelete") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideHardDeleteModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <p>{{ $t("orders.messages.hardDelete") }}</p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideHardDeleteModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-danger" @click="hardDeleteOrders">{{ $t("orders.hardDeleteConfirm") }}</md-button>
      </template>
    </modal>

    <modal v-if="splitModal" @close="hideSplitModal" class-name="split-orders-modal-container modal-fullscreen">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.splitOrder") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideSplitModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <SplitOrder :orders="splitOrders" :multiple="splitMultiple" :parseLocation="parseShippingSkuLocation" @close="hideSplitModal" @updated="afterSplitOrder" />
      </template>
    </modal>

    <modal v-if="exportModal" @close="hideExportModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.export") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideExportModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <h4>{{ $t("orders.messages.exportSelectedOrder") }}</h4>

        <p>
          <strong>{{ $t("orders.messages.doYouWantToExport") }}</strong>
        </p>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideExportModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-success" @click="handleCsvGenerate()">{{ $t("orders.triggerExport") }}</md-button>
      </template>
    </modal>

    <modal v-if="addManualOrderModal" @close="hideAddManualOrderModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.addOrder") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideAddManualOrderModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <tabs :tab-name="[$t('orders.order'), $t('orders.sku'), $t('orders.parts.title')]" color-button="success" content-flex-direction-column extraClass="tab-flat">
          <template slot="tab-pane-1">
            <ValidationObserver v-slot="{}" ref="addManualForm">
              <!-- <section class="md-layout"> -->
              <!-- <div class="md-layout-item md-size-50"> -->
              <ValidationProvider name="manualOrder.customerInvoiceNumber" rules="required" v-slot="{ errors }">
                <md-field>
                  <label>{{ $t("orders.customerInvoiceNumber") }}</label>
                  <md-input v-model="manualOrder.customerInvoiceNumber" type="text"></md-input>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </md-field>
              </ValidationProvider>

              <ValidationProvider name="manualOrder.customerIdNumber" rules="required" v-slot="{ errors }">
                <md-field>
                  <label>{{ $t("orders.customerIdNumber") }}</label>
                  <md-input v-model="manualOrder.customerIdNumber" type="text"></md-input>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </md-field>
              </ValidationProvider>
              <ValidationProvider name="manualOrder.customerOrderId" rules="required" v-slot="{ errors }">
                <md-field>
                  <label>{{ $t("orders.customerOrderId") }}</label>
                  <md-input v-model="manualOrder.customerOrderId" type="text"></md-input>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </md-field>
              </ValidationProvider>
              <section class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <div v-if="hasPermission('Read', 'Orders', 'ShippingStatusId')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                    <label v-if="!!manualOrder.shippingStatusId">{{ $t("orders.status") }}</label>
                    <SelectOrderStatus v-model="manualOrder.shippingStatusId" :multiple="false" :customClass="'custom-select'" />
                  </div>
                </div>
                <div class="md-layout-item md-size-50">
                  <div v-if="hasPermission('Read', 'Orders', 'orderShippingCarrier')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                    <label v-if="!!manualOrder.orderShippingCarrier">{{ $t("orders.carrier") }}</label>
                    <SelectCarrier v-model="manualOrder.orderShippingCarrier" :default="true" :multiple="false" :customClass="'custom-select'" />
                  </div>
                </div>
              </section>
              <div v-if="hasPermission('Read', 'Orders', 'pickType')" class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                <label v-if="!!manualOrder.pickType">{{ $t("orders.pickType") }}</label>
                <SelectPickType v-model="manualOrder.pickType" :multiple="false" :customClass="'custom-select'" />
              </div>

              <md-field>
                <label>{{ $t("orders.shippingAddressCompany") }}</label>
                <md-input v-model="manualOrder.shippingAddressCompany" type="text"> </md-input>
              </md-field>
              <section class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.shippingAddressName") }}</label>
                    <md-input v-model="manualOrder.shippingAddressName" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.phoneNumber") }}</label>
                    <md-input v-model="manualOrder.phoneNumber" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.shippingAddressStreet") }}</label>
                    <md-input v-model="manualOrder.shippingAddressStreet" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.shippingAddressZipcode") }}</label>
                    <md-input v-model="manualOrder.shippingAddressZipcode" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.shippingAddressTown") }}</label>
                    <md-input v-model="manualOrder.shippingAddressTown" type="text"> </md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("orders.shippingAddressCountry") }}</label>
                    <md-input v-model="manualOrder.shippingAddressCountry" type="text"> </md-input>
                  </md-field>
                </div>
              </section>

              <!-- </div> -->
              <!-- </section> -->
            </ValidationObserver>
          </template>
          <template slot="tab-pane-2">
            <Skus v-model="manualOrder.orderSkus" v-if="hasPermission('Read', 'Orders', 'OrderSkus')" />
          </template>
          <template slot="tab-pane-3">
            <Parts v-model="manualOrder.parts" />
          </template>
        </tabs>
      </template>
      <template slot="footer">
        <md-button class="md-secondary" @click="hideAddManualOrderModal">{{ $t("orders.close") }}</md-button>
        <md-button class="md-success" @click="addOrder">{{ $t("orders.save") }}</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import Parts from "../../components/Orders/Parts.vue";
import OrderImageGallery from "../../components/Orders/OrderImageGallery.vue";
import Skus from "../../components/Orders/Skus.vue";
import { debounce } from "lodash";
import { mapState } from "vuex";
import { format } from "date-fns";
import numeral from "numeral";
import VueJsonToCsv from "vue-json-to-csv-async/src/JsonToCsv";

import { Modal, Tabs } from "@/components";
import SimpleDateTimePicker from "@/components/DateTimePicker/SimpleDateTimePicker.vue";
import CSLoading from "../../components/Loading/CSLoading.vue";
import axiosFactory from "../../services/axios.factory";
import { EventBus } from "@/helpers/event-bus";
import stickyTableHeader from "@/helpers/stickyTableHeader";
import { hasPermission, assignedWarehouse, canView, isAdmin } from "../../mixins/auth";
import { normalizeStatusName } from "../../mixins/formats";
import SplitOrder from "../../components/Orders/SplitOrder.vue";
import SelectCarrier from "../../components/SelectCarrier/SelectCarrier.vue";
import CarrierLogo from "../../components/SelectCarrier/CarrierLogo.vue";
import SelectOrderStatus from "../../components/SelectOrderStatus/SelectOrderStatus.vue";
import SelectPickType from "../../components/SelectPickType/SelectPickType.vue";
import PdfPreviewModal from "../../components/PdfPreviewModal.vue";
import fileService from "../../services/file.service";

export default {
  components: {
    Parts,
    OrderImageGallery,
    Skus,
    CSLoading,
    Modal,
    Tabs,
    SplitOrder,
    SimpleDateTimePicker,
    SelectCarrier,
    SelectOrderStatus,
    SelectPickType,
    CarrierLogo,
    PdfPreviewModal,
    "vue-json-to-csv": VueJsonToCsv,
  },
  data() {
    const userWarehouse = assignedWarehouse();
    return {
      isLoading: true,
      editModal: false,
      createModal: false,
      addSkuModal: false,
      setStatusModal: false,
      picklistPreview: { show: false, files: [] },
      deleteModal: false,
      hardDeleteModal: false,
      exportModal: false,
      validateAddressesModal: false,
      proposalModal: false,
      proposalOrder: null,
      proposalData: null,
      addressValidationStatusFilter: [],
      addManualOrderModal: false,
      orderFile: null,
      files: {
        orderFile: null,
      },
      shippingStatusId: null,
      shippingSkuAmount: null,
      shippingSkuName: null,
      shippingSkuCarrier: null,
      shippingSkuLocation: null,
      shippingSkuInventory: null,
      shippingSkuInventoryObj: null,
      form: {},
      manualOrder: {
        orderSkus: [],
        parts: [],
      },
      enableBulky: false,
      filterBulky: false,
      filterReklaImages: false,
      imageModal: false,
      imageInvoiceNumber: null,
      imageAllowUpload: false,
      imageSaving: false,
      filter: {
        keywords: null,
        invoiceNumber: null,
        warehouseId: userWarehouse ? userWarehouse.id : null,
        storageLocationLevel1: null,
        shippingStatusId: "1",
        bulky: null,
        hasReklaImages: null,
        pickTypes: null,
        addressValidationStatusId: null,
      },
      tableColumns: ["actions", "status", "orderType", "customer", "shipping", "sku", "reklaImages", "carrier", "orderDate"],
      tableOptions: {
        headings: {
          actions: () => this.$t("orders.table.actions"),
          customer: () => this.$t("orders.table.customer"),
          shipping: () => this.$t("orders.table.shipping"),
          sku: () => this.$t("orders.table.sku"),
          reklaImages: () => this.$t("orders.images.column"),
          status: () => this.$t("orders.table.status"),
          carrier: () => this.$t("orders.table.carrier"),
          orderType: () => this.$t("orders.table.orderType"),
          orderDate: () => this.$t("orders.table.orderDate"),
        },
        perPage: 100,
        perPageValues: [100, 200, 500, 1000],
        filterable: false,
        sortable: [],
        params: {},
        resizableColumns: false,
        requestFunction: this.requestFunction,
        responseAdapter: this.responseFunction,
        rowClassCallback: this.rowClassCallback,
        pagination: {
          show: true,
        },
        texts: {
          count: this.$t("table.count"),
          limit: this.$t("table.records"),
          noResults: this.$t("table.noRecord"),
        },
        columnsClasses: {
          customer: "text-left",
          shipping: "mw-400 text-left",
          sku: "text-left",
        },
      },
      tableData: [],
      totalItems: 0,
      totalSelectedItems: 0,
      currentPage: 1,
      table: null,
      isCheckAll: false,
      selectedItems: new Set(),
      deselectedItems: new Set(),
      selectedExports: new Map(),
      shippingStatusOptions: [],
      productId: "",
      products: [],
      inventories: [],
      selectedInventories: [],
      pickTypes: [
        { id: "na", name: "N/A" },
        { id: "SQP", name: this.$t("orders.pickTypes.SQP") },
        { id: "CAB", name: this.$t("orders.pickTypes.CAB") },
        { id: "CHECK", name: this.$t("orders.pickTypes.CHECK") },
      ],
      splitOrders: [],
      splitModal: false,
      splitMultiple: false,
    };
  },
  computed: {
    ...mapState("warehouses", {
      stateStorageLocations: "storageLocations",
      warehouseOptions: "warehouses",
    }),
    // Aktionsmenue nur zeigen, wenn mindestens eine Aktion erlaubt ist.
    hasAnyOrderAction() {
      return ["Export", "Send", "Delete", "HardDelete", "ValidateAddresses"].some((c) => hasPermission("Write", "Orders", c));
    },
    addressValidationFilterOptions() {
      return [0, 1, 2, 3, 4, 5].map((id) => ({ id, name: this.$t(`orders.addressValidation.statuses.${id}`) }));
    },
    proposalReasonText() {
      if (!this.proposalData || !this.proposalData.reason) return null;
      if (this.proposalData.source === "rules") {
        return this.proposalData.reason
          .split(",")
          .map((code) => {
            const key = `orders.addressValidation.reasons.${code.trim()}`;
            return this.$te(key) ? this.$t(key) : code.trim();
          })
          .join(", ");
      }
      return this.proposalData.reason;
    },
    proposalFields() {
      if (!this.proposalOrder || !this.proposalData) return [];
      const fields = [
        { key: "company", label: this.$t("orders.company"), current: this.proposalOrder.shippingAddressCompany },
        { key: "name", label: this.$t("orders.name"), current: this.proposalOrder.shippingAddressName },
        { key: "street", label: this.$t("orders.streetAndNumber"), current: this.proposalOrder.shippingAddressStreet },
        { key: "zipcode", label: this.$t("orders.addressValidation.zipcode"), current: this.proposalOrder.shippingAddressZipcode },
        { key: "town", label: this.$t("orders.addressValidation.town"), current: this.proposalOrder.shippingAddressTown },
      ];
      return fields.map((f) => {
        const proposed = this.proposalData[f.key];
        return { ...f, proposed, changed: (proposed || "") !== (f.current || "") };
      });
    },
    carriers() {
      const carrierItems = structuredClone(this.$store.state.shippingData.carriers) || [];
      // carrierItems.push({ id: -1, name: this.$t("orders.speditionWithoutNumbers") });
      carrierItems.forEach((carrier) => {
        switch (carrier.id) {
          case -1:
            carrier.name = this.$t("orders.speditionWithoutNumbers");
            break;
          default:
            break;
        }
      });
      return carrierItems;
    },
    storageLocations() {
      return this.stateStorageLocations || [];
    },
    level1Options() {
      if (!this.stateStorageLocations) return [];
      const set = new Set(
        this.stateStorageLocations
          .filter((sl) => sl && sl.level1 && sl.isActive)
          .map((sl) => sl.level1)
      );
      return [...set].sort();
    },
    hasCheckedAll() {
      return this.totalItems > 0 && this.totalSelectedItems === this.totalItems;
    },
    isWarehouseAssigned() {
      return !!assignedWarehouse();
    },
    shouldShowCheckAll() {
      return true;
      let flag = false;
      if (this.filter.pickTypes && this.filter.pickTypes.length > 0) {
        flag = !(this.filter.pickTypes.includes("CHECK") || this.filter.pickTypes.includes("na"));
        if (this.filter.pickTypes.length === 1 && this.filter.pickTypes[0] === "") {
          flag = false;
        }
      }
      // console.log("flag", flag, this.filter.pickTypes);
      return flag;
    },
    carrierOptions() {
      return (
        this.$store.state.shippingData.carriers?.filter((item) => {
          return item.id !== -1;
        }) || []
      );
    },
  },
  watch: {
    enableBulky(bool) {
      if (!bool) {
        this.filter.bulky = null;
      } else {
        if (this.filterBulky) {
          this.filter.bulky = "true";
        } else {
          this.filter.bulky = "false";
        }
      }

      this.debounceApplyFilters();
    },
    filterBulky(bool) {
      if (bool) {
        this.filter.bulky = "true";
      } else {
        this.filter.bulky = "false";
      }

      this.debounceApplyFilters();
    },
    filterReklaImages(bool) {
      this.filter.hasReklaImages = bool ? true : null;
      this.debounceApplyFilters();
    },
  },
  methods: {
    openImages(row, allowUpload) {
      this.imageInvoiceNumber = row.customerInvoiceNumber;
      this.imageAllowUpload = allowUpload && this.hasPermission("Write", "Orders", "Images");
      this.imageModal = true;
    },
    hideImages() {
      // Abbrechen/X verwirft die vorgemerkten Aenderungen - serverseitig passiert nichts
      this.$refs.imageGallery?.discard();
      this.imageModal = false;
      this.imageInvoiceNumber = null;
    },
    async saveImages() {
      this.imageSaving = true;
      try {
        const ok = await this.$refs.imageGallery.commit();
        if (!ok) return; // Fehlertext steht in der Galerie, Modal bleibt offen
        this.imageModal = false;
        this.imageInvoiceNumber = null;
        // Zaehler/Icon in der Liste koennen sich geaendert haben
        this.$refs.table.refresh();
      } finally {
        this.imageSaving = false;
      }
    },
    showAddManulaOrderModal() {
      this.addManualOrderModal = true;
      this.manualOrder = {
        orderSkus: [],
      };
    },
    showSplitModal(order) {
      if (order?.id) {
        this.splitOrders.push({ ...order });

        this.splitMultiple = false;
      } else {
        // const orders = this.tableData.map((i) => {
        //   return structuredClone({ ...i });
        // });
        // console.log("orders", orders);
        // this.splitOrders = orders;
        this.splitMultiple = true;
      }
      this.splitModal = true;
    },
    showSplitAllOrders() {
      this.splitModal = true;
    },
    handleChangeCarrier(val) {
      this.filter.carrier = val ? val.join(",") : null;
      this.debounceApplyFilters();
    },
    handleChangeStatus(val) {
      this.filter.shippingStatusId = val ? val.join(",") : null;
      this.debounceApplyFilters();
    },
    handleChangePickTypes(val) {
      this.filter.pickTypes = val ?? null;
      this.debounceApplyFilters();
    },
    hideSplitModal() {
      this.splitModal = false;
      this.splitMultiple = false;
      this.splitOrders = [];
      this.applyFilters({});
    },
    afterSplitOrder() {
      this.applyFilters({});
      this.hideSplitModal();
      this.splitOrders = [];
    },
    hideEditModal() {
      this.editModal = false;
    },
    showEditModal(item) {
      this.editModal = true;
      this.form = structuredClone({ ...item });
    },
    hideCreateModal() {
      this.createModal = false;
    },
    hideAddSkuModal() {
      this.addSkuModal = false;

      this.resetSkuModal();
    },
    hideSetStatusModal() {
      this.setStatusModal = false;
    },
    hideDeleteModal() {
      this.deleteModal = false;
    },
    hideExportModal() {
      this.exportModal = false;
    },
    hideAddManualOrderModal() {
      this.addManualOrderModal = false;
      this.resetFormAdd();
    },
    resetFormAdd() {
      this.manualOrder = {
        orderSkus: [],
      };
    },
    debounceApplyFilters: debounce(function () {
      this.applyFilters({});
    }, 300),
    applyFilters(filters) {
      stickyTableHeader({ selector: "#table-orders" });
      const pickTypes = this.filter.pickTypes ? this.filter.pickTypes.join(",") : null;
      this.$refs.table.options.params = {
        ...this.$refs.table.options.params,
        ...this.filter,
        ...filters, //
        pickTypes: pickTypes,
        // pageIndex: 0,
      };
      this.handleCheckAll(false);
      this.currentPage = 1;
      this.$refs.table.setPage(this.currentPage);
    },
    requestFunction(data) {
      const { page, limit, orderBy, ascending, ...filters } = data;
      this.currentPage = page;
      const params = {
        ...this.filter,
        ...filters,
        pageIndex: this.currentPage,
        pageSize: limit,
        orderBy,
        ascending,
      };
      if (!params.hasOwnProperty("shippingStatusId")) {
        params.shippingStatusId = "1";
      }
      if (!params.warehouseId) {
        params.warehouseId = undefined;
      }

      this.isLoading = true;
      return axiosFactory()
        .get(`/orders`, { params })
        .catch(function (e) {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    responseFunction({ data }) {
      this.totalItems = data.total;
      const selected = !!this.isCheckAll;
      this.tableData = data.data.map((i, index) => {
        if (this.deselectedItems.has(i.id)) {
          this.selectedExports.delete(i.id);
          return { ...i, selected: false, index };
        }

        if (selected) {
          this.selectedItems.add(i.id);
          this.selectedExports.set(i.id, i);
        }
        return { ...i, selected, index };
      });

      return {
        data: this.tableData,
        count: data.total,
      };
    },
    rowClassCallback(row) {
      if (row.shippingStatusName === "unshipped") {
        return "shipping-status-unshipped";
      }

      if (row.shippingStatusName === "shipped") {
        return "shipping-status-shipped";
      }

      if (row.shippingStatusName === "shipping number included") {
        return "shipping-status-shipping-number-included";
      }

      if (row.shippingStatusName === "exported") {
        return "shipping-status-exported";
      }

      if (row.shippingStatusName === "error") {
        return "shipping-status-error";
      }

      return "";
    },
    normalizeOptionForSlot(option) {
      return typeof option === "object" ? option : { [this.label]: option };
    },
    addOrder() {
      this.isLoading = true;
      const inputs = this.prepareFormData(this.manualOrder);
      axiosFactory()
        .post(`/orders`, inputs)
        .then((res) => {
          this.applyFilters({});
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.added"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .then(() => {
          this.hideAddManualOrderModal();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    prepareFormData(rawData) {
      const skus = rawData.orderSkus.map((sku) => {
        const parts = sku.shippingSkuLocation.split(":");
        const shippingSku = sku.id ? sku.shippingSkuLocation : parts[parts.length - 1];
        return {
          ...sku,
          shippingSkuLocation: shippingSku,
        };
      });

      const formData = { ...rawData, orderSkus: skus };

      return formData;
    },
    editOrder() {
      this.isLoading = true;
      const inputs = this.prepareFormData(this.form);
      axiosFactory()
        .put(`/orders/${this.form.id}`, inputs)
        .then((res) => {
          this.applyFilters({});
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.updated"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .then(() => {
          this.hideEditModal();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async copy(templateOrder) {
      const lastId = await axiosFactory()
        .get("/orders/generate-next-customer-orderId", {
          params: {
            customerInvoiceNumber: templateOrder.customerInvoiceNumber,
          },
        })
        .then((res) => {
          return res.data?.data || null;
        })
        .catch((err) => {
          console.error(err);
          return null;
        });
      const shippingStatus = this.shippingStatusOptions.find((i) => i.name === "unshipped");
      this.manualOrder = {
        customerInvoiceNumber: templateOrder.customerInvoiceNumber,
        customerIdNumber: templateOrder.customerIdNumber,
        //customerOrderId: templateOrder.customerOrderId,
        shippingStatusId: shippingStatus && shippingStatus.id,
        shippingAddressCompany: templateOrder.shippingAddressCompany,
        shippingAddressName: templateOrder.shippingAddressName,
        phoneNumber: templateOrder.phoneNumber,
        shippingAddressStreet: templateOrder.shippingAddressStreet,
        shippingAddressZipcode: templateOrder.shippingAddressZipcode,
        shippingAddressTown: templateOrder.shippingAddressTown,
        shippingAddressCountry: templateOrder.shippingAddressCountry,
        pickType: "CHECK",
        orderSkus: [],
      };

      // const parts = templateOrder.customerOrderId.split("-");
      // if (parts.length < 2) {
      //   this.manualOrder.customerOrderId = templateOrder.customerOrderId + "-1";
      // } else {
      //   this.manualOrder.customerOrderId = parts[0] + "-" + (parseInt(parts[1]) + 1);
      // }
      this.manualOrder.customerOrderId = lastId;

      this.addManualOrderModal = true;
    },

    handleSelectRow(row) {
      row.selected = !row.selected;
      if (row.selected) {
        this.totalSelectedItems += 1;
        this.selectedItems.add(row.id);
        this.deselectedItems.delete(row.id);

        this.selectedExports.set(row.id, row);
      } else {
        this.totalSelectedItems -= 1;
        this.selectedItems.delete(row.id);
        this.deselectedItems.add(row.id);

        this.selectedExports.delete(row.id);
      }

      if (this.$refs.checkAllInput) {
        this.$refs.checkAllInput.indeterminate = this.totalSelectedItems > 0 && this.totalSelectedItems !== this.totalItems;
      }
    },
    handleCheckAll(forceBool) {
      if (typeof forceBool === "boolean") {
        this.isCheckAll = forceBool;
      } else {
        if (!this.hasCheckedAll) {
          this.isCheckAll = true;
        } else if (this.hasCheckedAll && !this.isCheckAll) {
          this.isCheckAll = false;
        } else {
          this.isCheckAll = !this.isCheckAll;
        }
      }

      if (this.isCheckAll) {
        this.totalSelectedItems = +this.totalItems;
      } else {
        this.totalSelectedItems = 0;
        this.selectedItems.clear();
        this.selectedExports.clear();
      }

      this.deselectedItems.clear();

      for (let index = 0; index < this.tableData.length; index++) {
        this.tableData[index].selected = !!this.isCheckAll;
        if (this.isCheckAll) {
          this.selectedItems.add(this.tableData[index].id);
          this.selectedExports.set(this.tableData[index].id, this.tableData[index]);
        }
      }
    },
    async handleFetchSelectedItems() {
      if (!this.isCheckAll) {
        return Promise.resolve();
      }

      const isLocalFull = this.totalItems === this.selectedItems.size;
      if (isLocalFull) {
        return Promise.resolve();
      }

      try {
        this.isLoading = true;

        const pickTypes = this.filter.pickTypes ? this.filter.pickTypes.join(",") : null;
        const params = { ...this.filter, pickTypes, pageSize: 10000000 };
        const { data: resp } = await axiosFactory().get("/orders", { params });
        for (let index = 0; index < resp.data.length; index++) {
          if (!this.deselectedItems.has(resp.data[index].id)) {
            this.selectedItems.add(resp.data[index].id);
            this.selectedExports.set(resp.data[index].id, resp.data[index]);
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async setOrdersStatus() {
      await this.handleFetchSelectedItems();

      const payload = {
        orderIds: Array.from(this.selectedItems),
      };

      this.isLoading = true;
      try {
        // Liefert die Dateinamen (CSV + Picklisten je Lager); die Dateien liegen unter "Auftragsexporte"
        const { data } = await axiosFactory().put("/orders/set_orders_status", payload);
        this.applyFilters({});
        this.$notify({
          timeout: 2500,
          message: this.$t("orders.messages.statusUpdated"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        await this.downloadExportFile(data.csvFileName);
        if (data.picklists && data.picklists.length) {
          await this.openPicklistPreview(data.picklists);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.hideSetStatusModal();
        this.isLoading = false;
      }
    },
    async downloadExportFile(fileName) {
      const blob = await fileService.downloadFile(fileName, "ExportOrder");
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async openPicklistPreview(picklists) {
      const files = [];
      for (const p of picklists) {
        const blob = await fileService.downloadFile(p.fileName, "ExportOrder");
        files.push({
          title: `${p.warehouseName} (${p.warehouseCode})`,
          fileName: p.fileName,
          url: window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" })),
        });
      }
      this.picklistPreview = { show: true, files };
    },
    closePicklistPreview() {
      this.picklistPreview.files.forEach((f) => window.URL.revokeObjectURL(f.url));
      this.picklistPreview = { show: false, files: [] };
    },
    onValidationFilterChange() {
      this.filter.addressValidationStatusId = this.addressValidationStatusFilter.length ? this.addressValidationStatusFilter.map((o) => o.id).join(",") : null;
      this.debounceApplyFilters();
    },
    parseOldAddress(row) {
      if (!row.oldAddress) return null;
      try {
        return JSON.parse(row.oldAddress);
      } catch (e) {
        return null;
      }
    },
    formatOldAddress(row) {
      const old = this.parseOldAddress(row);
      if (!old) return null;
      return [old.company, old.name, old.street, `${old.zipcode || ""} ${old.town || ""}`.trim()].filter(Boolean).join(", ");
    },
    openProposalModal(row) {
      this.proposalOrder = row;
      try {
        this.proposalData = JSON.parse(row.addressValidationProposal);
      } catch (e) {
        this.proposalData = null;
      }
      this.proposalModal = true;
    },
    hideProposalModal() {
      this.proposalModal = false;
      this.proposalOrder = null;
      this.proposalData = null;
    },
    acceptProposal() {
      if (!this.proposalOrder) return;
      this.isLoading = true;
      axiosFactory()
        .put(`/orders/${this.proposalOrder.id}/accept_address_proposal`)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.addressValidation.messages.accepted"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.applyFilters({});
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.hideProposalModal();
          this.isLoading = false;
        });
    },
    rejectProposal() {
      if (!this.proposalOrder) return;
      this.isLoading = true;
      axiosFactory()
        .put(`/orders/${this.proposalOrder.id}/reject_address_proposal`)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.addressValidation.messages.rejected"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.applyFilters({});
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.hideProposalModal();
          this.isLoading = false;
        });
    },
    async validateAddresses() {
      await this.handleFetchSelectedItems();
      const orderIds = Array.from(this.selectedItems);
      this.validateAddressesModal = false;
      if (orderIds.length === 0) {
        this.$notify({
          timeout: 2500,
          message: this.$t("orders.addressValidation.messages.noSelection"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "warning",
        });
        return;
      }

      this.isLoading = true;
      const totals = { validated: 0, proposals: 0, notValidated: 0, notCheckable: 0, errors: 0 };
      try {
        for (let i = 0; i < orderIds.length; i += 20) {
          const chunk = orderIds.slice(i, i + 20);
          const res = await axiosFactory().put("/orders/validate_addresses", { orderIds: chunk });
          const data = res.data.data;
          totals.validated += data.validated;
          totals.proposals += data.proposals;
          totals.notValidated += data.notValidated;
          totals.notCheckable += data.notCheckable;
          totals.errors += data.errors;
          if (orderIds.length > 20) {
            this.$notify({
              timeout: 1200,
              message: this.$t("orders.addressValidation.messages.progress", { done: Math.min(i + 20, orderIds.length), total: orderIds.length }),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "info",
            });
          }
        }
        this.$notify({
          timeout: 8000,
          message: this.$t("orders.addressValidation.messages.summary", totals),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
      } catch (err) {
        console.log(err);
        this.$notify({
          timeout: 4000,
          message: this.$t("orders.addressValidation.messages.failed"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } finally {
        this.isLoading = false;
        this.applyFilters({});
      }
    },
    async setOrdersStatusDeleted() {
      await this.handleFetchSelectedItems();

      const payload = {
        orderIds: Array.from(this.selectedItems),
      };

      this.isLoading = true;
      axiosFactory()
        .put("/orders/set_orders_status_deleted", payload)
        .then(() => {
          this.applyFilters({});
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.statusUpdated"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.hideDeleteModal();
          this.isLoading = false;
        });
    },
    hideHardDeleteModal() {
      this.hardDeleteModal = false;
    },
    async hardDeleteOrders() {
      if (!this.isCheckAll && this.selectedItems.size === 0) {
        this.$notify({
          timeout: 2500,
          message: this.$t("orders.messages.noSelection"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      await this.handleFetchSelectedItems();

      const payload = {
        orderIds: Array.from(this.selectedItems),
      };

      this.isLoading = true;
      axiosFactory()
        .put("/orders/delete_from_database", payload)
        .then(() => {
          this.applyFilters({});
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.hardDeleteSuccess"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.hardDeleteError"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.hideHardDeleteModal();
          this.isLoading = false;
        });
    },
    handleFileUpload(key, event) {
      this.files[key] = event.target.files[0];
    },
    importOrderFile() {
      this.isLoading = true;
      const formData = new FormData();
      if (this.files.orderFile) {
        formData.append("orderFile", this.files.orderFile);
      }
      axiosFactory()
        .post(`/orders/import`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.$notify({
            timeout: 2500,
            message: this.$t("orders.messages.fileImported"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });

          this.applyFilters({});
        })
        .then(() => {
          this.hideExportModal();
        })
        .catch((err) => {
          //console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    dateFilterChanaged(d, key) {
      this.filter[key] = d.startDate;
      this.applyFilters({});
    },
    clearDatetime(key) {
      this.filter[key] = null;
      this.applyFilters({});
    },
    parseShippingSkuLocation(shippingSkuLocation, orderSkuId, shippingRef) {
      if (!shippingSkuLocation) return "";

      if (shippingSkuLocation.toUpperCase() === "VS") {
        return "PP";
      }

      const locations = [];
      try {
        const parts = shippingSkuLocation.split(";");
        for (let index = 0; index < parts.length; index++) {
          const element = parts[index];
          const inventoryParts = element.split(":");
          let locationId = parseInt(inventoryParts[0]);
          let location = this.storageLocations.find((l) => l.id === locationId);

          let inventory = parseInt(inventoryParts[1]);
          if ((!inventory || isNaN(inventory)) && shippingRef && this.selectedInventories.length) {
            console.log("parseShippingSkuLocation", location, inventoryParts, shippingRef, this.selectedInventories, "---", this.storageLocations, location);
            const item = this.selectedInventories.find((i) => i.sku === shippingRef.shippingSkuName);
            inventory = item ? item.inventory : "";
          }

          if (location) {
            locations.push(`${location.fullName}:${inventory}`);
          }
        }
      } catch (e) {
        console.log(e);
      }

      return locations.join(",");
    },

    async exportOrders() {
      try {
        await this.handleFetchSelectedItems();

        this.isLoading = true;

        const filtered = Array.from(this.selectedExports.values());
        const items = [];

        for (let i = 0; i < filtered.length; i++) {
          let { id, title, shippingStatusId, skus, orderSkus, selected, index, ...data } = filtered[i];
          const skuStr = [];
          if (orderSkus && orderSkus.length > 0) {
            for (let index = 0; index < orderSkus.length; index++) {
              const sku = orderSkus[index];
              let str = `${sku.shippingSkuAmount} x ${sku.shippingSkuName}`;
              if (sku.shippingSkuCarrier || sku.shippingSkuLocation) {
                str = str + ` (${sku.shippingSkuCarrier}, ${this.parseShippingSkuLocation(sku.shippingSkuLocation)})`;
              }
              skuStr.push(str);
            }
          }
          data.orderShippingWeight = data.orderShippingWeight ? data.orderShippingWeight.toFixed(2).replace(".", ",") : "";
          items.push({ id: `${id}`, ...data, orderSkus: skuStr.join(",") });
        }

        return items;
      } catch (error) {
        console.error(error);
        return [];
      } finally {
        this.exportModal = false;
        this.isLoading = false;
      }
    },
    getExportOrderTitle() {
      return `orders_export_${format(new Date(), "yyyyMMdd_HHmmss")}`;
    },
    handleCsvGenerate() {
      if (!this.$refs.csvGenerator) {
        return;
      }

      this.$refs.csvGenerator.handleClick();
    },
    getProducts(keywords) {
      axiosFactory()
        .get(`/shipping_data/products?keywords=${keywords}&includeBWare=true`)
        .then((res) => {
          this.products = res.data.data.map((p) => p.sku);
        });
    },
    hasPermission(permissionName, tableName, columnName) {
      return hasPermission(permissionName, tableName, columnName);
    },
    afterbuyOrderUrl(row) {
      if (!row.customerOrderId) return null;
      const orderId = String(row.customerOrderId).split("-")[0].trim();
      if (!orderId) return null;
      return `https://farm04.afterbuy.de/afterbuy/auktionsliste.aspx?art=edit&id=${orderId}`;
    },
    isAdmin() {
      return isAdmin();
    },
    canView(menu) {
      return canView(menu);
    },
    canSelectOrders() {
      return isAdmin() || this.hasAnyOrderAction;
    },
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
  created() {
    this.$store.dispatch("shippingData/getShippingStatuses").then((res) => {
      this.shippingStatusOptions = [{ id: 0, name: "" }, ...res];
    });
    this.$store.dispatch("shippingData/getCarriers");
    this.$store.dispatch("warehouses/getStorageLocations");
    this.$store.dispatch("warehouses/getWarehouses");
  },
  mounted() {
    stickyTableHeader({ selector: "#table-orders" });
    EventBus.$on("language:changed", ({ locale }) => {
      numeral.locale(locale);
      this.applyFilters({});
    });
  },
  updated() {
    EventBus.$emit("scroll:changed");
  },
  beforeDestroy() {
    EventBus.$off("language:changed");
    EventBus.$off("scroll:changed");
  },
};
</script>
<style lang="css" src="./Orders.css"></style>
<style>
.md-menu-content-bottom-start {
  z-index: 10001;
}
</style>
<style scoped lang="scss">
.table-transparent {
  background-color: transparent !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.shipping-bulky {
  cursor: default;
  line-height: 24px;
  vertical-align: middle;
}

.documents i {
  color: #7f915a !important;
}
.md-success {
  background-color: #7f915a !important;
}
.empty-product {
  background-color: gray;
}

.date-title {
  margin-bottom: 0;
  text-align: left;
  font-size: 0.85em;
  color: #888;
}

.tr-footer-shippping-plan td {
  background-color: darkgray;
}

.cell-sku ul {
  margin: 0;
  padding-left: 15px;
}
.address-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  i {
    font-size: 15px !important;
    height: 15px;
    width: 15px;
    color: #999 !important;
    margin: 0;
  }
}
.list-parts {
  list-style-type: square;
}
.border-top {
  border-top: 1px dashed #795548;
}
.list-parts li::marker {
  color: #999;
}
</style>
